import { ReactNode } from 'react';

interface CheckboxProps {
  isLabel?: boolean;
  label: string | ReactNode;
  labelClassname?: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  customTextLable?: string;
  customClassIcon?: string;
  checkboxTestId?: string;
  isDangerousHTML?: boolean;
  checkboxContainerClassName?: string;
  isCursorPointer?: boolean;
  variant?: CheckboxVariant;
}

type CheckboxVariant = 'primary' | 'secondary';

const checkboxVariantStyles: Record<
  CheckboxVariant,
  {
    base: string;
    checked: string;
    unchecked: string;
    icon: string;
  }
> = {
  primary: {
    base: 'border-supportiveRed',
    checked: 'bg-supportiveRed border-supportiveRed',
    unchecked: 'bg-inherit border-supportiveRed hover:bg-reliableBlack10',
    icon: 'text-white',
  },
  secondary: {
    base: 'border-black',
    checked: 'bg-white border-black',
    unchecked: 'bg-white border-black hover:bg-gray-100',
    icon: 'text-black',
  },
};

const Checkbox = ({
  isLabel = true,
  label,
  labelClassname = '',
  checked,
  onChange,
  disabled = false,
  customTextLable = '',
  customClassIcon = '',
  checkboxTestId,
  isDangerousHTML = false,
  checkboxContainerClassName = '',
  isCursorPointer = true,
  variant = 'primary',
  ...props
}: CheckboxProps & React.ComponentProps<'input'>) => {
  const styles = checkboxVariantStyles[variant];

  return (
    <label
      className={`${labelClassname} items-center ${isCursorPointer ? 'cursor-pointer' : 'cursor-default'}`}
    >
      <div className={`relative ${checkboxContainerClassName}`}>
        <input
          id="cb-syarat"
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          data-testid={checkboxTestId}
          {...props}
        />
        <div
          className={`w-[17px] h-[17px] rounded-none border-2 ${
            checked ? styles.checked : styles.unchecked
          } `}
        >
          {checked && (
            <svg
              className={`w-3.5 h-3.5
              absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${styles.icon} ${customClassIcon}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          )}
        </div>
      </div>

      {isLabel &&
        (isDangerousHTML ? (
          <div
            className={`flex-1 text-reliableBlack ${
              disabled ? 'text-gray-400' : ''
            } ${customTextLable}`}
            dangerouslySetInnerHTML={{ __html: label as string }}
            style={{ overflowWrap: 'anywhere' }}
          />
        ) : (
          <div
            className={`flex-1 text-reliableBlack ${
              disabled ? 'text-gray-400' : ''
            } ${customTextLable}`}
            style={{ overflowWrap: 'anywhere' }}
          >
            {label}
          </div>
        ))}
    </label>
  );
};

export default Checkbox;
